const PriceService = {
  /**
   * Add price
   * @param {Object} payload
   */
  createPrice: async (payload) => {
    const { data } = await ovpFetch('/prices', {
      method: 'POST',
      body: JSON.stringify(payload),
    });
    return data;
  },
  /**
   * Update price
   * @param {String} id
   * @param {Object} payload
   */
  updatePrice: async (id, payload) => {
    const { data } = await ovpFetch(`/prices/${id}`, {
      method: 'POST',
      body: JSON.stringify(payload),
    });
    return data;
  },
  /**
   * Delete price
   * @param {String} id
   */
  deletePrice: async (id) => {
    await ovpFetch(`/prices/${id}`, {
      method: 'DELETE',
    });
    return true;
  },
};

// eslint-disable-next-line
export { PriceService };